// Generated by ReScript, PLEASE EDIT WITH CARE

import * as V2f$Linear from "lumi-linear/lib/es6/src/V2f.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as BoundingBox$Linear from "lumi-linear/lib/es6/src/BoundingBox.res.js";
import * as LineSegmentf$Linear from "lumi-linear/lib/es6/src/LineSegmentf.res.js";

function toRect(param) {
  let aabb = BoundingBox$Linear.axisAlignedBoundingBox([
    param.from,
    param.to
  ]);
  let match = V2f$Linear.mapToString(aabb.pos);
  let match$1 = V2f$Linear.mapToString(aabb.size);
  return JsxRuntime.jsx("rect", {
    height: match$1[1],
    width: match$1[0],
    fill: "white",
    fillOpacity: "0.4",
    stroke: "grey",
    strokeWidth: "1",
    vectorEffect: "non-scaling-stroke",
    x: match[0],
    y: match[1]
  });
}

function toLine(param) {
  let match = param.to;
  let match$1 = param.from;
  return JsxRuntime.jsx("line", {
    strokeWidth: "1",
    vectorEffect: "non-scaling-stroke",
    x1: match$1[0].toString(),
    x2: match[0].toString(),
    y1: match$1[1].toString(),
    y2: match[1].toString()
  });
}

let rel = LineSegmentf$Linear.toVec;

export {
  rel,
  toRect,
  toLine,
}
/* V2f-Linear Not a pure module */
